<template>
	<span @click="endCountFn()">{{countString}}</span>
</template>
<script>
export default {
	name: 'showTime',
	data() {
		return {
			isStart: false,
			globalTimer: null,
			countString: '0秒', //用来显示时间
			day: 0,
			hour: 0,
			minute: 0,
			second: 0,
			millisecond: 0,
			countVal: this.countVals, //获取初始值
			pauseTime: 0
		}
	},
	props: {
		isStarts: {
			type: Boolean,
			default: false
		},
		countVals: {
			type: Number,
			default: 0
		}
	},
	watch: {
		// isStart: function(val) {
		// 	debugger
		// 	if (val) {
		// 		this.startCountFn()
		// 	}
		// },
		isStarts: {
			deep: true,
			handler: function(val) {
				if (val) {
					this.isStart = val
					this.startCountFn()
				}
			}
		},
		countVals: {
			deep: true,
			handler: function(val) {
				// if (val > 0 && this.isStart) {
				// 	this.startCountFn()
				// } else {
				// 	this.endCountFn()
				// }
				if (this.isStart) {
					this.startCountFn()
				}
			}
		}
	},
	created: function() {},
	methods: {
		counterFn: function(counterTime) {
			var vm = this
			var nowDate = new Date().getTime()
			if (vm.pauseTime == 0) {
				var num = nowDate - counterTime //计算时间毫秒差
			} else {
				vm.pauseTime = vm.pauseTime + 10
				var num = vm.pauseTime - counterTime //计算时间毫秒差
			}
			var leave1 = num % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
			var leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
			var leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
			vm.day = Math.floor(num / (24 * 3600 * 1000)) //计算相差天数
			vm.hour = Math.floor(leave1 / (3600 * 1000)) //计算相差小时
			vm.minute = Math.floor(leave2 / (60 * 1000)) //计算相差分钟
			vm.second = Math.round(leave3 / 1000) //计算相差秒
			if (vm.day > 0) {
				vm.countString = `${vm.day}天 ${vm.hour}小时 ${vm.minute}分 ${vm.second}秒`
			} else if (vm.hour > 0) {
				vm.countString = `${vm.hour}小时 ${vm.minute}分 ${vm.second}秒`
			} else if (vm.minute > 0) {
				vm.countString = `${vm.minute}分 ${vm.second}秒`
			} else {
				vm.countString = `${vm.second}秒`
			}
		},
		startCountFn: function() {
			var vm = this
			if (vm.isStart) {
				vm.countVals = vm.countVals
					? vm.countVals
					: new Date().getTime()
				var timer = setInterval(function() {
					vm.counterFn(vm.countVals)
				}, 10)
				vm.globalTimer = timer
			}
		},
		endCountFn: function() {
			let vm = this
			if (vm.isStart) {
				window.clearInterval(vm.globalTimer)
				vm.globalTimer = null
				vm.isStart = false
				vm.pauseTime = new Date().getTime()
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/customer/talks/showTime.vue